import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import { Status, Wrapper } from '@googlemaps/react-wrapper';
import { IGoogleMap } from '@models/IGoogleMap';
import { forwardRef } from 'react';
import InnerGoogleMap from './InnerGoogleMap';

interface Props extends IGoogleMap {
  readonly googleMapsApiKey: string;
  readonly loadingSpinnerExtraClasses?: string;
}

const GoogleMap = forwardRef(({ googleMapsApiKey, ...rest }: Props, ref) => {
  const renderMap = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return <LoadingSpinner extraClasses="h-full" />;
      case Status.FAILURE:
        return <h4>Error Loading Map</h4>;
      default:
        return <InnerGoogleMap ref={ref} {...rest} />;
    }
  };

  return <Wrapper apiKey={googleMapsApiKey} render={renderMap} />;
});

export default GoogleMap;
